import React from 'react';
import PropTypes from 'prop-types';

import DataCard from '../../../common/card/DataCard';

import getTotalPaidPayments from '../../../../utils/getTotalPaidPayments';
import getTotalRefundedValue from '../../../../utils/getTotalRefundedValue';

export const PaymentDetails = ({ data }) => {
  const { netOrderTotal, balanceDue, paymentTiming } = data;

  const details = [
    { label: 'Payment Timing', data: paymentTiming },
    { label: 'Net Order Total', data: Number(netOrderTotal).toFixed(2), currency: true },
    { label: 'Total Paid', data: Number(getTotalPaidPayments(data) ?? 0).toFixed(2), currency: true },
    { label: 'Total Refunded', data: Number(getTotalRefundedValue(data) ?? 0).toFixed(2), currency: true },
    { label: 'Balance Due', data: Number(balanceDue).toFixed(2), currency: true },
  ];

  return <DataCard title="Payment Details" cardData={details} />;
};

PaymentDetails.propTypes = {
  data: PropTypes.shape({
    netOrderTotal: PropTypes.number,
    balanceDue: PropTypes.number,
    paymentTiming: PropTypes.string,
  }).isRequired,
};
